import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterRoutingModule } from './footer-routing.module';
import { FooterComponent } from './footer.component';


@NgModule({
  exports: [
    FooterComponent
  ],
  declarations: [
    
  ],
  imports: [
    CommonModule,
    FooterRoutingModule,
    FooterComponent
  ]
})
export class FooterModule { }
